import type { FormEvent, ReactNode } from 'react';

import { Anchor, Card, Flex, Group, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router';

import { LogoText } from '@/components/displays/LogoText/LogoText';
import { AuthDivider } from './AuthDivider';

type AuthFormLayoutProps = {
	title: string;
	header?: ReactNode;
	onSubmit: (event: FormEvent<HTMLFormElement>) => void;
	fields: ReactNode;
	auxLink?: {
		text: string;
		to: string;
	};
	actionButton: ReactNode;
	/** Shown under the action button. */
	auxButton?: ReactNode;
	altAction?: {
		preText: string;
		text: string;
		to: string;
	};
	footerDividerText?: string;
	footer?: ReactNode;
};

export default function AuthFormLayout(props: AuthFormLayoutProps) {
	const { title, header, onSubmit, fields, auxLink, actionButton, auxButton, altAction, footerDividerText, footer } =
		props;
	return (
		<Flex
			direction="column"
			justify="center"
			align="center"
			h="100dvh"
			style={{
				paddingTop: 'var(--safe-area-top)',
				paddingBottom: 'var(--safe-area-bottom)',
				paddingLeft: 'var(--safe-area-left)',
				paddingRight: 'var(--safe-area-right)',
			}}
		>
			<LogoText maw={180} my="lg" />
			<Flex
				direction="column"
				w={{
					base: '100%',
					sm: '50%',
					md: '35%',
					lg: '30%',
				}}
				px="lg"
			>
				<Card shadow="lg" p={30}>
					{header && <Stack mb="lg">{header}</Stack>}
					<Title order={4} pb="lg" ta="start">
						{title}
					</Title>
					<form onSubmit={onSubmit}>
						<Stack>
							{fields}

							{auxLink && (
								<Anchor c="dark" component={Link} to={auxLink.to} ta="center" fz="80%">
									{auxLink.text}
								</Anchor>
							)}

							{actionButton}

							{auxButton}

							{altAction && (
								<Group justify="center" gap="4px">
									<Text ta="center" c="dimmed" fz="sm" span>
										{altAction.preText}
									</Text>
									<Anchor c="dark" component={Link} to={altAction.to} fz="sm">
										{altAction.text}
									</Anchor>
								</Group>
							)}

							{footer && (
								<>
									<AuthDivider label={footerDividerText ?? ''} />
									{footer}
								</>
							)}
						</Stack>
					</form>
				</Card>
			</Flex>
		</Flex>
	);
}
